export const OrderDetailCommands = {
    OPEN_SIDEBAR_ONLINE_ORDER: '[ORDER_DETAIL] OPEN_SIDEBAR_ONLINE_ORDER',
    OPEN_SIDEBAR_ONLINE_ORDER_SUCCESS: '[ORDER_DETAIL] OPEN_SIDEBAR_ONLINE_ORDER_SUCCESS',
    CLOSE_SIDEBAR_ONLINE_ORDER: '[ORDER_DETAIL] CLOSE_SIDEBAR_ONLINE_ORDER',
    CLOSE_SIDEBAR_ONLINE_SUCCESS: '[ORDER_DETAIL] CLOSE_SIDEBAR_ONLINE_SUCCESS',
    CLOSE_SIDEBAR_ONLINE_ERROR: '[ORDER_DETAIL] CLOSE_SIDEBAR_ONLINE_ERROR',
    CLOSE_SIDEBAR_ONLINE_DUE_NAVIGATION: '[ORDER_DETAIL] CLOSE_SIDEBAR_ONLINE_DUE_NAVIGATION',
};
